import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Sparkles } from 'lucide-react';
const heroImages = ['https://cdn.magicpatterns.com/uploads/mHVgw9s4dvc7ZNg4SyCCbX/IMG-20260510-WA0027.jpg', 'https://cdn.magicpatterns.com/uploads/f1R2Vny6zLJmaijCMSyGae/IMG-20260510-WA0031.jpg'];
export function Hero() {
  const [activeIdx, setActiveIdx] = useState(0);
  // Both slides sit INSIDE the viewport, so loading="lazy" on the second is
  // ignored by the browser. Mount slide 2 only once slide 1 has finished, so a
  // single photo — not two multi-megabyte ones — gates the first paint.
  const [firstLoaded, setFirstLoaded] = useState(false);
  useEffect(() => {
    if (!firstLoaded) return;
    const id = setInterval(() => {
      setActiveIdx(i => (i + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(id);
  }, [firstLoaded]);
  return <section className="relative min-h-[100svh] flex items-center bg-ivory text-midnight overflow-hidden pt-24 pb-12 md:py-0" data-id="element-196" data-mp="381xiwrlewq70">
      {/* Background decorative blob */}
      <div className="absolute top-[-10%] right-[-5%] w-[60vw] h-[60vw] bg-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-197" data-mp="3j6o8rb5sq6lv" />
      <div className="absolute bottom-[-10%] left-[-10%] w-[50vw] h-[50vw] bg-midnight/5 rounded-full blur-[80px] pointer-events-none" data-id="element-198" data-mp="39b4hj226fw3g" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 grid lg:grid-cols-[1.2fr_1fr] gap-12 items-center" data-id="element-199" data-mp="3e7l59v5gs8g0">
        {/* Left Content */}
        <div className="flex flex-col items-start pt-10 lg:pt-0" data-id="element-200" data-mp="358howyxom757">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8,
          rotate: -5
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: -2
        }} transition={{
          type: 'spring',
          damping: 20,
          stiffness: 100
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-midnight text-ivory rounded-full text-xs font-bold tracking-widest uppercase mb-8 shadow-lg" data-id="element-201" data-mp="35audhuxy3fr8">
            <Sparkles className="w-3 h-3 text-gold" data-id="element-202" data-mp="naa1gt0e9mn1" />
            <span data-id="element-203" data-mp="n9i3jbjbrctl">Est. 2019</span>
            <span className="w-1 h-1 rounded-full bg-gold" data-id="element-204" data-mp="ibgmew5glnkr" />
            <span data-id="element-205" data-mp="i9vqp37erylb"></span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: [0.16, 1, 0.3, 1]
        }} className="text-6xl sm:text-7xl md:text-8xl lg:text-[7.5rem] font-display font-extrabold leading-[0.9] tracking-tighter mb-6 text-midnight" data-id="element-206" data-mp="de6ost7x25lu">
            Raising <br data-id="element-207" data-mp="3lsp3hdsd4jef" />
            Global <br data-id="element-208" data-mp="3lu04j5ufbd1u" />
            <span className="font-serif italic font-medium text-gold pr-4" data-id="element-209" data-mp="3luia4t2z73mf">
              Endtime Armies
            </span>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="relative mb-10" data-id="element-210" data-mp="1x9b6f48dr7e5">
            <p className="text-xl md:text-2xl font-serif text-charcoal/80 max-w-md italic" data-id="element-211" data-mp="2b2so0jhiaa1j">
              For the Body of Christ.
            </p>
            <p className="text-base md:text-lg text-charcoal/70 mt-4 max-w-lg font-medium leading-relaxed" data-id="element-212" data-mp="2ky44p7ch5rbx">
              Camp David Prayer Platform (CDPP) is a community of intercessors,
              standing in the gap and raising Kingdom Giants through the study
              of God's word, prayer, and outreach.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-wrap gap-4 w-full sm:w-auto" data-id="element-213" data-mp="uou3jav21yby">
            <a href="#contact" className="group flex items-center gap-2 bg-midnight text-ivory px-8 py-4 rounded-full font-bold text-sm tracking-wide hover:bg-gold hover:text-midnight transition-colors shadow-xl" data-id="element-214" data-mp="e77knvdd7plp">
              Join Us
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" data-id="element-215" data-mp="3ct0o9m66arjh" />
            </a>
            <a href="#programs" className="flex items-center gap-2 border-2 border-midnight/10 bg-white text-midnight px-8 py-4 rounded-full font-bold text-sm tracking-wide hover:border-midnight transition-colors" data-id="element-216" data-mp="3mpn6e37474ht">
              Our Programs
            </a>
          </motion.div>
        </div>

        {/* Right Image Card */}
        <motion.div initial={{
        opacity: 0,
        x: 50,
        rotate: 5
      }} animate={{
        opacity: 1,
        x: 0,
        rotate: 2
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 120,
        delay: 0.2
      }} className="relative w-full max-w-md mx-auto lg:max-w-none aspect-[4/5] lg:aspect-[3/4]" data-id="element-217" data-mp="19gklyypp5zlx">
          <div className="absolute inset-0 bg-gold rounded-[2.5rem] rotate-[-4deg] scale-105 opacity-20" data-id="element-218" data-mp="1x6x3906u18p6" />
          <div className="relative w-full h-full rounded-[2rem] overflow-hidden shadow-2xl border-4 border-white bg-midnight" data-id="element-219" data-mp="1j7xaphg789nq">
            {heroImages.slice(0, firstLoaded ? heroImages.length : 1).map((src, i) => <img key={src} src={src} alt="Camp David Outreach" width={900} height={1200} loading="eager" decoding="async" fetchPriority={i === 0 ? 'high' : 'low'} onLoad={i === 0 ? () => setFirstLoaded(true) : undefined} onError={i === 0 ? () => setFirstLoaded(true) : undefined} className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${activeIdx === i ? 'opacity-100 scale-105' : 'opacity-0 scale-100'}`} data-id="element-220" data-mp="bun9pj1wuqif" data-mpi={i} />)}
            <div className="absolute inset-0 bg-gradient-to-t from-midnight/60 via-transparent to-transparent" data-id="element-221" data-mp="1lswqv5mjjhtt" />

            {/* Image pagination dots */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 bg-midnight/30 backdrop-blur-md px-3 py-2 rounded-full" data-id="element-222" data-mp="1gv3hy4tus9pu">
              {heroImages.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-500 ${activeIdx === i ? 'w-6 bg-gold' : 'w-1.5 bg-ivory/60'}`} data-id="element-223" data-mp="3b8w7f7sho9jh" data-mpi={i} />)}
            </div>
          </div>

          {/* Floating Badges */}
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -top-6 -right-6 bg-gold text-midnight font-bold px-6 py-3 rounded-full rotate-12 shadow-xl border-2 border-ivory text-sm tracking-widest uppercase" data-id="element-224" data-mp="3sgvo8set0oex">
            Global Movement
          </motion.div>

          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1
        }} className="absolute -bottom-8 -left-8 bg-midnight text-ivory font-display font-bold text-2xl px-6 py-4 rounded-3xl -rotate-6 shadow-xl border-2 border-white" data-id="element-225" data-mp="39t0edjmbbur3">
            7+ Years
          </motion.div>
        </motion.div>
      </div>
    </section>;
}